module.exports = __webpack_public_path__ + "img/5.590ca6c7.png";